import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kalyani-deshpande',
  templateUrl: './kalyani-deshpande.component.html',
  styleUrls: ['./kalyani-deshpande.component.scss']
})
export class KalyaniDeshpandeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
